import Customer from './Customer'
import User from '../user/User'

export default class GlassesJob {
  static ENDPOINT = '/customer/glasses-jobs'

  id: string
  externalID: string
  customerID: string
  customer?: Customer
  userID: string
  user?: User
  status: 'waiting' | 'in_progress' | 'ready'
  notes: string
  position: number
  createdAt: Date
  updatedAt: Date

  constructor() {
    this.id = ''
    this.externalID = ''
    this.customerID = ''
    this.userID = ''
    this.status = 'waiting'
    this.notes = ''
    this.position = 0
    this.createdAt = new Date()
    this.updatedAt = new Date()
  }

  static from(data: any): GlassesJob {
    const job = new GlassesJob()
    job.id = data.id || ''
    job.externalID = data.externalID || ''
    job.customerID = data.customerID || ''
    job.customer = data.customer ? Customer.from(data.customer) : undefined
    job.userID = data.userID || ''
    job.user = data.user ? User.from(data.user) : undefined
    job.status = data.status || 'waiting'
    job.notes = data.notes || ''
    job.position = data.position || 0
    job.createdAt = data.createdAt ? new Date(data.createdAt) : new Date()
    job.updatedAt = data.updatedAt ? new Date(data.updatedAt) : new Date()
    return job
  }
}
